module.exports = __webpack_public_path__ + "media/images/award-badges-mobile-kr-5421d6bd8300564d6571f700758ab32d.svg";